var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8, _path9, _g9, _path10, _g10, _path11, _g11, _path12, _g12, _path13, _g13, _path14, _g14, _path15, _g15, _path16, _g16, _path17, _g17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 81,
    viewBox: "0 0 189 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_572_20579)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 113,
    y: 18,
    width: 57,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.857 18.7012L143.403 39.4123H169.153L151.969 27.9192L113.857 18.7012Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.707 0.507687L107.051 36.8594L162.326 57.6249L175.982 21.2732L120.707 0.507687Z",
    fill: "url(#paint0_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 39,
    width: 43,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.404 39.4121L127.86 62.3748L169.153 39.4121H143.404Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.397 21.291L117.782 45.3965L138.618 80.5014L179.232 56.396L158.397 21.291Z",
    fill: "url(#paint1_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 14,
    width: 25,
    height: 19
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M138.25 15.4593L162.583 32.813L150.973 14.8184L138.25 15.4593Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.096 2.65385L129.254 24.0488L150.733 44.9725L171.575 23.5775L150.096 2.65385Z",
    fill: "url(#paint2_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 144,
    y: 40,
    width: 26,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.209 55.1276L165.894 47.7966L169.261 40.5605L144.209 55.1276Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.428 28.1589L136.995 46.8691L155.046 67.5466L176.479 48.8364L158.428 28.1589Z",
    fill: "url(#paint3_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 31,
    width: 24,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M174.077 37.6162L170.621 40.9791H187.734L187.741 40.9778L178.042 33.2507L164.521 31.0527L174.077 37.6162Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.713 30.2322L164.172 31.0625L164.55 41.7937L188.091 40.9634L187.713 30.2322Z",
    fill: "url(#paint4_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 13,
    width: 22,
    height: 10
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.363 17.3562L142.453 22.459L129.544 13.252L121.363 17.3562Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.704 5.54821L117.999 20.998L139.108 30.1588L145.813 14.709L124.704 5.54821Z",
    fill: "url(#paint5_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 44,
    width: 4,
    height: 7
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M166.16 50.8931L169.628 49.6126L169.12 44.5332L166.16 50.8931Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.389 43.6317L164.504 50.4297L169.361 51.7768L171.247 44.9788L166.389 43.6317Z",
    fill: "url(#paint6_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 48,
    width: 9,
    height: 8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8751 48.7764C36.4934 48.775 36.1126 48.81 35.7376 48.8809C35.3645 48.9559 35.0048 49.0861 34.6702 49.2674C34.3317 49.4424 34.0354 49.6893 33.8024 49.9909C33.4545 50.5103 33.2687 51.1214 33.2687 51.7466C33.2687 52.3718 33.4545 52.9829 33.8024 53.5023C34.0354 53.8039 34.3317 54.0508 34.6702 54.2258C35.0047 54.4075 35.3645 54.5382 35.7376 54.6136C36.1126 54.6841 36.4935 54.7186 36.8751 54.7168C37.8295 54.7069 38.7808 54.6075 39.7167 54.4197C40.0055 54.3647 40.2668 54.3083 40.4814 54.2533V55.0125C40.4814 55.0222 40.4511 55.0359 40.392 55.0538C40.3329 55.0717 40.2545 55.0923 40.1719 55.1115L39.9134 55.1679L39.6768 55.2175L39.5585 55.2395C39.0342 55.3465 38.5036 55.4195 37.9699 55.4582C36.589 55.5618 35.4148 55.4242 34.4474 55.0455C34.3993 55.0263 34.3388 55.0001 34.27 54.9671C34.1647 54.9134 34.0632 54.8528 33.966 54.7856C33.8314 54.6943 33.7023 54.5951 33.5795 54.4885C33.4329 54.3573 33.2989 54.2127 33.1793 54.0566C33.038 53.8772 32.915 53.6841 32.8121 53.4803C32.6975 53.243 32.609 52.9939 32.548 52.7376C32.4748 52.4371 32.4351 52.1294 32.4297 51.8202V51.6826C32.435 51.3734 32.4747 51.0657 32.548 50.7652C32.609 50.5084 32.6975 50.2589 32.8121 50.0211C32.915 49.8173 33.038 49.6243 33.1793 49.4448C33.2989 49.2887 33.4329 49.1441 33.5795 49.0129C33.7023 48.9067 33.8314 48.808 33.966 48.7172C34.0633 48.6497 34.1648 48.5886 34.27 48.5343C34.3388 48.5013 34.3993 48.4751 34.4474 48.4559C35.4139 48.0809 36.588 47.9433 37.9699 48.0433C38.5034 48.0803 39.0339 48.1511 39.5585 48.2551C40.1738 48.3935 40.4814 48.4692 40.4814 48.482V49.2426C40.26 49.1862 40.0055 49.1312 39.7167 49.0748C38.7809 48.8866 37.8295 48.7867 36.8751 48.7764Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.8099 47.8457H32.3057V55.5398H40.8099V47.8457Z",
    fill: "url(#paint7_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 48,
    width: 11,
    height: 8
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9992 48.4521C48.0514 48.4713 48.1106 48.4974 48.1766 48.5277C48.4236 48.6596 48.6544 48.8198 48.8643 49.005C49.0094 49.1372 49.1437 49.2807 49.2659 49.4341C49.4106 49.6112 49.5356 49.8035 49.6387 50.0077C49.7538 50.246 49.8433 50.4959 49.9055 50.7531C49.9812 51.056 50.0218 51.3666 50.0266 51.6788V51.8163C50.0218 52.1281 49.9812 52.4382 49.9055 52.7406C49.8433 52.9979 49.7538 53.2478 49.6387 53.4861C49.5359 53.6908 49.4109 53.8837 49.2659 54.061C49.1437 54.2145 49.0094 54.358 48.8643 54.4902C48.7416 54.5977 48.6116 54.6965 48.4751 54.7859C48.377 54.8513 48.2755 54.9114 48.1711 54.9661C48.1051 54.9977 48.0459 55.0224 47.9937 55.0417C46.3467 55.634 44.5448 55.634 42.8978 55.0417C42.8374 55.0195 42.7781 54.9943 42.7203 54.9661C42.6157 54.9117 42.5142 54.8516 42.4164 54.7859C42.2792 54.6962 42.1483 54.5974 42.0244 54.4902C41.8777 54.3588 41.7424 54.2153 41.62 54.061C41.4745 53.884 41.3495 53.6911 41.2472 53.4861C41.1321 53.2478 41.0427 52.9979 40.9804 52.7406C40.9048 52.4382 40.8641 52.1281 40.8594 51.8163V51.6788C40.8641 51.3666 40.9048 51.056 40.9804 50.7531C41.0427 50.4959 41.1321 50.246 41.2472 50.0077C41.3498 49.8032 41.4749 49.6109 41.62 49.4341C41.8432 49.1494 42.1123 48.904 42.4164 48.7079C42.5142 48.6422 42.6157 48.582 42.7203 48.5277C42.785 48.4974 42.8455 48.4713 42.8978 48.4521C44.5448 47.8597 46.3467 47.8597 47.9937 48.4521H47.9992ZM48.6594 53.5177C49.0179 53.0473 49.1972 52.4573 49.1972 51.7476C49.1972 51.0379 49.017 50.4473 48.6566 49.976C48.5021 49.7703 48.3165 49.5898 48.1065 49.441C47.9063 49.2976 47.6903 49.1776 47.4628 49.0834C47.2401 48.9947 47.01 48.9261 46.7751 48.8784C46.5624 48.8334 46.3475 48.7995 46.1314 48.7767C45.9484 48.7602 45.7628 48.7519 45.5812 48.7519H45.335C45.1479 48.7519 44.9623 48.7602 44.7848 48.7767C44.5686 48.7995 44.3538 48.8334 44.1411 48.8784C43.9062 48.9261 43.6761 48.9947 43.4534 49.0834C43.2259 49.1776 43.0099 49.2976 42.8097 49.441C42.5997 49.5898 42.4141 49.7703 42.2596 49.976C41.9074 50.4391 41.7282 51.0296 41.7218 51.7476C41.7153 52.4655 41.8946 53.0556 42.2596 53.5177C42.4137 53.7238 42.5994 53.9044 42.8097 54.0528C43.0099 54.1962 43.2259 54.3162 43.4534 54.4104C43.6756 54.5003 43.9059 54.5689 44.1411 54.6153C44.3537 54.661 44.5686 54.695 44.7848 54.7171C44.9678 54.7336 45.1534 54.7419 45.335 54.7419H45.5812C45.7683 54.7419 45.9539 54.7336 46.1314 54.7171C46.3476 54.695 46.5625 54.661 46.7751 54.6153C47.0103 54.5689 47.2405 54.5003 47.4628 54.4104C47.6903 54.3162 47.9063 54.1962 48.1065 54.0528C48.3168 53.9044 48.5024 53.7238 48.6566 53.5177H48.6594Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0324 47.4648H40.8047V56.0241H50.0324V47.4648Z",
    fill: "url(#paint8_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 48,
    width: 9,
    height: 8
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7772 48.122H59.5818V54.8025C59.5924 54.9587 59.5508 55.114 59.4635 55.244C59.4 55.3321 59.3147 55.4023 59.216 55.4475C59.151 55.4759 59.0805 55.4895 59.0096 55.4874C58.9146 55.4842 58.8211 55.4622 58.7347 55.4225C58.6483 55.3828 58.5706 55.3263 58.5062 55.2564L52.1188 49.1V55.3746H51.3142V48.6956C51.3035 48.5393 51.3441 48.3839 51.4297 48.2527C51.4926 48.1651 51.5769 48.095 51.6745 48.0491C51.9166 47.9501 52.1559 48.0134 52.3897 48.2417L58.7772 54.4118V48.122Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.8306 47.752H50.9922V55.5341H59.8306V47.752Z",
    fill: "url(#paint9_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 48,
    width: 9,
    height: 8
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6788 53.0639C68.7544 53.3439 68.7516 53.6394 68.6705 53.918C68.597 54.1992 68.4482 54.455 68.24 54.658C68.0402 54.8451 67.8069 54.993 67.5523 55.094C67.3106 55.1986 67.0584 55.2769 66.8 55.3278C66.5306 55.3768 66.2588 55.4117 65.9857 55.4323C65.5731 55.4681 65.1866 55.486 64.8125 55.486H64.5649C64.4604 55.486 64.2527 55.4681 63.9432 55.4433C63.6338 55.4186 63.3339 55.3883 63.0437 55.3526C62.7535 55.3168 62.422 55.259 62.052 55.1793C61.7168 55.1089 61.3865 55.0171 61.0631 54.9042V54.1202C61.609 54.3026 62.1688 54.4405 62.737 54.5328C63.2163 54.6169 63.6997 54.6752 64.1853 54.7075L64.7231 54.7322C66.1764 54.7322 67.1026 54.5631 67.5014 54.2247C67.6596 54.0963 67.772 53.9202 67.8219 53.7227C67.8661 53.5233 67.8321 53.3146 67.727 53.1395C67.665 53.0444 67.5828 52.9641 67.4863 52.9043C67.3942 52.8426 67.2955 52.7913 67.192 52.7516C67.1053 52.72 66.9953 52.687 66.8646 52.6499C66.8087 52.6334 66.0792 52.466 64.6763 52.1478C63.2734 51.8296 62.5687 51.6683 62.5623 51.6637C62.345 51.6045 62.1786 51.5564 62.0644 51.5179C61.9181 51.4666 61.7768 51.4021 61.6421 51.3253C61.4882 51.2449 61.3488 51.1394 61.2295 51.0131C61.0683 50.8447 60.9541 50.637 60.898 50.4107C60.8261 50.1335 60.8313 49.8419 60.9132 49.5675C60.9902 49.2896 61.1403 49.0374 61.3478 48.8372C61.5474 48.6493 61.7807 48.5009 62.0355 48.3998C62.2765 48.2957 62.5277 48.2173 62.7851 48.166C63.0148 48.1233 63.2871 48.089 63.5994 48.0628C64.0065 48.0261 64.3994 48.0078 64.7781 48.0078C64.9156 48.0078 65.1137 48.0078 65.353 48.0202C65.5924 48.0326 66.0022 48.0642 66.5909 48.1261C67.0896 48.174 67.5839 48.2599 68.0695 48.3833V49.1577C67.5717 49.0329 67.0663 48.941 66.5565 48.8826C66.0242 48.8179 65.6089 48.7835 65.3186 48.7767H64.8744C63.4201 48.7767 62.4944 48.9463 62.0974 49.2856C61.9413 49.4123 61.8276 49.5836 61.7714 49.7766C61.7246 49.9726 61.7567 50.179 61.8608 50.3515C61.9832 50.5551 62.2735 50.7256 62.7342 50.8632C62.8388 50.8934 63.5792 51.0649 64.9555 51.3776C66.3319 51.6903 67.0255 51.848 67.0365 51.8507L67.1741 51.8892L67.3213 51.9319L67.4588 51.9704C67.5317 51.9924 67.5826 52.0089 67.606 52.0185L67.7435 52.0694C67.7905 52.0875 67.8364 52.1081 67.8811 52.1313L68.0048 52.1987C68.05 52.2215 68.0929 52.2487 68.1327 52.2799L68.2442 52.3706C68.2832 52.4038 68.3204 52.4392 68.3556 52.4766C68.5111 52.6419 68.6223 52.844 68.6788 53.0639Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8331 47.3262H60.8213V55.8868H68.8331V47.3262Z",
    fill: "url(#paint10_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 69,
    y: 48,
    width: 10,
    height: 8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3858 48.1211H78.1904V52.7631C78.1901 52.9219 78.1786 53.0805 78.156 53.2377C78.1264 53.4117 78.0804 53.5826 78.0185 53.7479C77.9542 53.9305 77.8664 54.1039 77.7571 54.2637C77.6318 54.4388 77.4832 54.5961 77.3156 54.7314C77.1201 54.8922 76.9036 55.0254 76.6719 55.1275C76.3829 55.2495 76.0805 55.3372 75.771 55.3888C75.3791 55.4567 74.9818 55.4894 74.584 55.4865H73.4204C73.0231 55.4894 72.6263 55.4567 72.2348 55.3888C71.9253 55.3372 71.623 55.2495 71.3339 55.1275C71.1023 55.0254 70.8857 54.8922 70.6902 54.7314C70.5226 54.5961 70.3741 54.4388 70.2487 54.2637C70.1394 54.1039 70.0516 53.9305 69.9874 53.7479C69.9254 53.5826 69.8794 53.4117 69.8498 53.2377C69.8266 53.0806 69.8151 52.9219 69.8154 52.7631V48.1211H70.6201V52.7631C70.6201 52.8663 70.6201 52.9516 70.6201 53.0231C70.6316 53.1331 70.6514 53.242 70.6792 53.3491C70.7084 53.4811 70.759 53.6075 70.8291 53.7232C70.9166 53.8522 71.0197 53.97 71.1359 54.0739C71.2798 54.2075 71.4466 54.3142 71.6283 54.3889C71.8688 54.484 72.1187 54.5536 72.3737 54.5966C72.7155 54.6574 73.0622 54.6864 73.4094 54.6832H74.573C74.9207 54.6865 75.2678 54.6575 75.6101 54.5966C75.8647 54.5536 76.1141 54.484 76.3542 54.3889C76.5364 54.3145 76.7037 54.2078 76.848 54.0739C76.9638 53.97 77.0664 53.8522 77.1533 53.7232C77.2245 53.6079 77.2756 53.4814 77.3046 53.3491C77.3318 53.2419 77.3515 53.133 77.3638 53.0231C77.3638 52.9516 77.3638 52.8663 77.3638 52.7631L77.3858 48.1211Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6551 47.4727H69.5566V55.7843H78.6551V47.4727Z",
    fill: "url(#paint11_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 79,
    y: 48,
    width: 8,
    height: 8
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4974 54.6339H86.4805V55.3794H79.6914V48.1172H80.496L80.4974 54.6339Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.6748 48.0703H79.5322V55.4274H86.6748V48.0703Z",
    fill: "url(#paint12_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 48,
    width: 9,
    height: 8
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1055 48.1211H93.043V48.8666H89.4766V55.3737H88.6733V48.8666H85.1055V48.1211Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.2025 48.0098H84.9473V55.4797H93.2025V48.0098Z",
    fill: "url(#paint13_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 93,
    y: 48,
    width: 2,
    height: 8
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9609 55.3739V48.1172H94.7656V55.3739H93.9609Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3831 47.9844H90.3438V55.5066H98.3831V47.9844Z",
    fill: "url(#paint14_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 48,
    width: 9,
    height: 8
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M103.838 48.122H104.637V54.8025C104.647 54.9587 104.606 55.114 104.518 55.244C104.455 55.3321 104.37 55.4023 104.271 55.4475C104.206 55.4758 104.135 55.4894 104.065 55.4874C103.969 55.4842 103.876 55.4622 103.79 55.4225C103.703 55.3828 103.626 55.3263 103.561 55.2564L97.1723 49.1V55.3746H96.3691V48.6956C96.3577 48.5393 96.3983 48.3836 96.4846 48.2527C96.5472 48.1648 96.6316 48.0947 96.7294 48.0491C96.9715 47.9501 97.2108 48.0134 97.4446 48.2417L103.832 54.4118L103.838 48.122Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.291 47.9316H96.0869V55.4896H105.291V47.9316Z",
    fill: "url(#paint15_linear_572_20579)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_572_20579",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 48,
    width: 10,
    height: 8
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M110.516 48.7776C109.891 48.774 109.27 48.8706 108.676 49.0637C108.135 49.2298 107.656 49.553 107.3 49.9921C106.938 50.4561 106.755 51.0416 106.75 51.7485C106.746 52.4555 106.929 53.0405 107.3 53.5036C107.656 53.9427 108.135 54.2659 108.676 54.432C109.27 54.6257 109.891 54.7223 110.516 54.718C111.486 54.7066 112.452 54.609 113.404 54.4265V51.7458H114.23V55.0151C114.23 55.0261 114.199 55.0399 114.139 55.0578C114.078 55.0757 114.001 55.0949 113.911 55.1142C113.82 55.1334 113.732 55.1527 113.635 55.1692L113.392 55.2132C113.318 55.227 113.278 55.2352 113.271 55.238C112.726 55.3422 112.174 55.4129 111.62 55.4498C110.194 55.5552 108.979 55.4177 107.976 55.0371C107.926 55.0179 107.864 54.9918 107.793 54.9587C107.684 54.9057 107.578 54.845 107.478 54.7772C107.338 54.6871 107.204 54.5879 107.077 54.4801C106.927 54.3491 106.789 54.2046 106.665 54.0482C106.518 53.8698 106.39 53.6767 106.282 53.4719C106.163 53.2356 106.07 52.9864 106.007 52.7292C105.932 52.429 105.892 52.1212 105.888 51.8118V51.6742C105.892 51.3635 105.932 51.0543 106.007 50.7527C106.07 50.495 106.163 50.2454 106.282 50.0086C106.389 49.8041 106.518 49.6114 106.665 49.4337C106.79 49.2783 106.928 49.1338 107.077 49.0018C107.203 48.8932 107.337 48.7943 107.478 48.7061C107.579 48.6396 107.684 48.5794 107.793 48.5259C107.864 48.4929 107.93 48.4668 107.976 48.4475C108.984 48.0697 110.199 47.9322 111.62 48.0349C112.174 48.0763 112.725 48.1489 113.271 48.2522C113.311 48.2636 113.351 48.2719 113.392 48.277L113.635 48.321L113.911 48.376C114.003 48.3952 114.077 48.4145 114.139 48.4324C114.201 48.4503 114.23 48.464 114.23 48.475V49.2397C113.989 49.1792 113.726 49.1242 113.44 49.0719C112.476 48.8861 111.498 48.7876 110.516 48.7776Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_572_20579)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.411 47.9668H105.652V55.5247H115.411V47.9668Z",
    fill: "url(#paint16_linear_572_20579)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7214 29.0977H-0.00683594V43.3223H3.68067V38.6458H10.8975C13.7391 38.6458 15.9659 36.6047 15.9659 34.0052V33.8099C15.9659 31.2103 13.614 29.0977 10.7242 29.0977M10.7242 35.3765H3.68067V32.3615H10.7242C11.5206 32.3615 12.2207 32.9351 12.2207 33.5898V34.0877C12.2207 34.7603 11.5096 35.3765 10.7242 35.3765Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4299 29.1035V43.3309H29.7548V37.5637H21.0195V43.3309H17.3457V29.1035H21.0195V34.2971H29.7548L29.7589 29.1035H33.4299Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.838 29.7394C48.4026 29.583 47.9585 29.4516 47.508 29.346C45.2619 28.8013 42.9182 28.8013 40.6721 29.346C40.2215 29.4528 39.777 29.5841 39.3407 29.7394C38.8978 29.8962 34.9985 31.4229 34.9834 36.2135C34.9985 40.9835 38.8978 42.5184 39.3407 42.678C39.7791 42.8368 40.2259 42.9713 40.679 43.081C41.7946 43.3373 42.9345 43.4729 44.0791 43.4853H44.1176C45.2589 43.4722 46.3956 43.3367 47.508 43.081C47.9582 42.9749 48.4022 42.8441 48.838 42.689C49.2823 42.5281 53.1637 40.9958 53.1802 36.2149C53.1637 31.4367 49.2823 29.9099 48.838 29.7504M49.4116 36.2149C49.4116 37.7416 48.7596 38.7869 47.4172 39.41C46.2343 39.9601 44.8259 40.0427 44.0914 40.0427C43.357 40.0427 41.9444 39.9601 40.7629 39.41C39.4122 38.7828 38.752 37.7375 38.752 36.2149C38.752 34.6923 39.4122 33.6428 40.7629 33.0143C41.9485 32.4641 43.3528 32.3871 44.0873 32.3871C44.8218 32.3871 46.2316 32.4655 47.4172 33.0143C48.7555 33.6387 49.4116 34.6827 49.4116 36.2149Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4146 32.3725V34.5993H68.535V37.8618H58.4146V40.0597H69.015V43.3222H54.7354V29.1113H69.015V32.3725H58.4146Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M87.76 29.101V41.2129C87.76 42.6654 86.7477 43.1921 86.4327 43.3173C86.1787 43.4214 85.9067 43.4747 85.6322 43.4741C85.0085 43.4658 84.4127 43.2141 83.9721 42.7726L74.5023 34.4403V43.3338H70.8271V31.2026C70.8271 29.7488 71.8408 29.2234 72.1503 29.0968C72.4065 28.9953 72.6794 28.9426 72.9549 28.9414C73.5785 28.9496 74.1744 29.2002 74.6164 29.6401L84.0848 37.9738V29.101H87.76Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6417 29.0996H89.9639V43.3311H93.6417V29.0996Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M114.241 43.3228H109.385L104.151 37.8775L98.9218 43.3228H94.0693L101.019 36.095L94.2894 29.0996H99.146L104.159 34.3125L109.16 29.0996H114.017L107.289 36.095L114.241 43.3228Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_572_20579",
    x1: 110.443,
    y1: 18.9457,
    x2: 164.389,
    y2: 39.2122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_572_20579",
    x1: 123.152,
    y1: 67.1514,
    x2: 161.135,
    y2: 44.6077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_572_20579",
    x1: 126.951,
    y1: 1.93307,
    x2: 167.741,
    y2: 41.6692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_572_20579",
    x1: 131.606,
    y1: 71.3981,
    x2: 168.909,
    y2: 38.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_572_20579",
    x1: 195.966,
    y1: 35.0965,
    x2: 171.097,
    y2: 35.9736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_572_20579",
    x1: 114.668,
    y1: 9.50288,
    x2: 173.476,
    y2: 35.0247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_572_20579",
    x1: 164.046,
    y1: 69.5136,
    x2: 172.531,
    y2: 38.9197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_572_20579",
    x1: -8.85166,
    y1: 54.0487,
    x2: 109.867,
    y2: 54.0487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_572_20579",
    x1: -15.4137,
    y1: 54.0488,
    x2: 116.429,
    y2: 54.0488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_572_20579",
    x1: -10.6413,
    y1: 54.0801,
    x2: 111.06,
    y2: 54.0801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_572_20579",
    x1: -19.5896,
    y1: 54.0463,
    x2: 116.43,
    y2: 54.0463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_572_20579",
    x1: -14.817,
    y1: 54.0484,
    x2: 117.623,
    y2: 54.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_572_20579",
    x1: 17.3978,
    y1: 54.0203,
    x2: 106.287,
    y2: 54.0203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_572_20579",
    x1: -5.8687,
    y1: 54.0491,
    x2: 109.27,
    y2: 54.0491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_572_20579",
    x1: -10.0439,
    y1: 54.065,
    x2: 105.692,
    y2: 54.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_572_20579",
    x1: -12.431,
    y1: 54.0494,
    x2: 102.708,
    y2: 54.0494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_572_20579",
    x1: -9.44857,
    y1: 54.0474,
    x2: 112.849,
    y2: 54.0474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E0D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#D41E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#DF352B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89A5B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_572_20579"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 188.092,
    height: 80,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/Logo-White.0752079570fddf5a4b4d58ae4a21847d.svg";
export { ForwardRef as ReactComponent };